/*
 * @Author: qiaoshiteng
 * @Date: 2023-06-19 13:39:09
 * @LastEditors: qiaoshiteng
 * @LastEditTime: 2023-07-10 10:33:02
 * @Description: 
 */
import config from "@/config";
import http from "@/utils/request";

export default {
    data: {
        list: {
            url: `${config.MAIN_URL}/api/v1/flyPlan/data`,
            name: "查询飞行计划列表",
            get: async function (params) {
                return await http.post(this.url, params);
            },
        },
        // 官方计划列表（新版服务站 galss 外部接口，替代旧版 GET /LSS/selectFssOfficialPlanListJy.do）
        // 入参：pageNumber、pageSize、positionId(必填)、executionDate、tailMark 等；出参：data 为 PageInfo{list,total}
        queryOfficialPlanList: {
            url: `${config.GALSS_URL}/api/v1/lss/officialPlan/external/queryList`,
            name: "查询飞行计划列表",
            get: async function (params) {
                return await http.post(this.url, params);
            },
        },
        // 官方计划详情（新版服务站 galss 外部接口，替代旧版 GET /LSS/selectOfficialPlanDetailJy.do）
        // 入参：id(计划主键)、planType(3=有人机当日,2=有人机次日,42=无人机当日,41=无人机次日)；出参：data 为 TodayPlanVO
        queryOfficialPlanDetail: {
            url: `${config.GALSS_URL}/api/v1/lss/officialPlan/external/queryDetail`,
            name: "查询飞行计划列表详情",
            get: async function (params) {
                return await http.post(this.url, params);
            },
        },
        save: {
            url: `${config.MAIN_URL}/api/v1/flyPlan/save`,
            name: "保存飞行计划",
            post: async function (params) {
                return await http.post(this.url, params);
            },
        },
        update: {
            url: `${config.MAIN_URL}/api/v1/flyPlan/update`,
            name: "修改飞行计划",
            post: async function (params) {
                return await http.post(this.url, params);
            },
        },
        delete: {
            url: `${config.MAIN_URL}/api/v1/flyPlan/delete`,
            name: '删除飞行计划',
            delete: async function (params) {
                return await http.delete(this.url + params);
            },
        },
        all: {
            url: `${config.MAIN_URL}/api/v1/flyPlan/getAll`,
            name: '飞行计划id',
            get: async function (params) {
                return await http.get(this.url + params);
            },
        },
        days: {
            url: `${config.MAIN_URL}/api/v1/flyPlan/month/days`,
            name: '模拟飞行数据时间集合',
            get: async function (params) {
                return await http.get(this.url + params);
            },
        },
        units: {
            url: `${config.MAIN_URL}/api/v1/flyPlan/get/unit`,
            name: '获取所有的服务站信息',
            get: async function () {
                return await http.get(this.url);
            },
        },
    },
    planData: {
        getCaptainFlightPlanList: {
            url: `${config.MAIN_URL}/api/v1/hw/flightPlan/getCaptainFlightPlanList`,
            name: '查询飞行计划列表',
            get: async function (params) {
                return await http.post(this.url, params);
            },
        },
        getUserRoleByUserIdAndSource: {
            url: `${config.MAIN_URL}/admin/api/getUserRoleByUserIdAndSource`,
            name: '获取当前角色所属部门',
            get: async function (params) {
                return await http.get(this.url, params);
            },
        },
        getFlightPlanApproval: {
            url: `${config.MAIN_URL}/api/v1/hw/flightPlan/getFlightPlanApproval`,
            name: '查询飞行计划列表',
            post: async function (params) {
                return await http.post(this.url, params);
            },
        },
        getUserListByDeptId: {
            url: `${config.MAIN_URL}/department/api/getUserListByDeptId`,
            name: '查询学员',
            get: async function (params) {
                return await http.get(this.url + params);
            },
        },
        getFlightPlanDetails: {
            url: `${config.MAIN_URL}/api/v1/hw/flightPlan/getFlightPlanDetails`,
            name: '查看飞行计划详情',
            get: async function (params) {
                return await http.get(this.url + params);
            },
        },
    },
    wrjPlan: {
        uavPlan: {
            url: `${config.ADSB_URL}/v1/api/uavLine`,
            name: '查询无人机飞行计划列表',
            get: async function (params) {
                return await http.get(this.url, params);
            },
        },
    },
    wrjUser: {
        uavFlyUser: {
            url: `${config.ADSB_URL}/v1/api/uavFlyUser`,
            name: '查询无人机飞行计划列表',
            get: async function (params) {
                return await http.get(this.url, params);
            },
            post: async function (params) {
                return await http.post(this.url, params);
            },
            put: async function (params) {
                return await http.put(this.url, params);
            },
            delete: async function (params) {
                return await http.delete(this.url + params);
            },
        },
    },
    wrjdevice: {
        uavData: {
            url: `${config.ADSB_URL}/v1/api/uavData`,
            name: '无人机设备信息',
            get: async function (params) {
                return await http.get(this.url, params);
            },
            post: async function (params) {
                return await http.post(this.url, params);
            },
            put: async function (params) {
                return await http.put(this.url, params);
            },
            delete: async function (params) {
                return await http.delete(this.url + params);
            },
        },
    },
    statistics: {
        queryDeviceRidUavData: {
            url: `${config.ADSB_URL}/api/ridUav/current/queryDeviceRidUavData`,
            name: '台站每个月数量统计',
            get: async function (params) {
                return await http.get(this.url, params);
            },
        },
        queryDeviceNameData: {
            url: `${config.ADSB_URL}/api/ridUav/current/queryDeviceNameData`,
            name: '台站设备号',
            get: async function (params) {
                return await http.get(this.url, params);
            },
        },
        queryDayFlightList: {
            url: `${config.ADSB_URL}/api/ridUav/current/queryDayFlightList`,
            name: '具体台站设备',
            get: async function (params) {
                return await http.get(this.url, params);
            },
        },
        queryRidUavNum: {
            url: `${config.ADSB_URL}/api/ridUav/current/queryRidUavNum`,
            name: '获取无人机列表',
            get: async function (params) {
                return await http.get(this.url, params);
            },
        },
        queryRidUavFlightDate: {
            url: `${config.ADSB_URL}/api/ridUav/current/queryRidUavFlightDate`,
            name: '获取无人机编号飞行日期',
            get: async function (params) {
                return await http.get(this.url, params);
            },
        }



    }
};
